// src/App.tsx - SÖZLEŞME SİSTEMİ EKLENMİŞ VERSİYON

import React, { useState, useEffect } from 'react';
import { BrowserRouter, useNavigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './pages/Login';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import StaffDashboard from './pages/StaffDashboard';
import TermsAgreementModal, { DeclineWarningModal } from './pages/TermsAgreementModal';
import LoadingSpinner from './components/ui/loadingSpinner';
import './index.css';

function AppContent() {
  const {
    isAuthenticated,
    isLoading,
    logout,
    user,
    hasAcceptedTerms,
    acceptTerms,
    declineTerms,
  } = useAuth();

  const [showDeclineWarning, setShowDeclineWarning] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const [isDeclining, setIsDeclining] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Oturum yoksa daima /login (referans linki ?ref= varsa /register'a); oturum varsa auth sayfalarından temizle
  useEffect(() => {
    if (isLoading) return;
    const onAuthPage = location.pathname === '/login' || location.pathname === '/register';
    if (!isAuthenticated) {
      const ref = new URLSearchParams(location.search).get('ref');
      if (ref && location.pathname !== '/register') {
        // Referans linki ile gelindi → ?ref korunarak kayıt moduna
        navigate(`/register?ref=${encodeURIComponent(ref)}`, { replace: true });
      } else if (!ref && !onAuthPage) {
        navigate('/login', { replace: true });
      }
    } else if (onAuthPage) {
      const dest = user?.role === 'Admin' ? '/admin' : user?.role === 'Staff' ? '/staff' : '/';
      navigate(dest, { replace: true });
    }
  }, [isLoading, isAuthenticated, user?.role, location.pathname, location.search, navigate]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // Admin / Staff kontrolü
  const isAdmin = user?.role === 'Admin';
  const isStaff = user?.role === 'Staff';

  // Sözleşme onaylama handler
  const handleAcceptTerms = async () => {
    setIsAccepting(true);
    try {
      await acceptTerms();
    } catch {
      // toast already handled in context
    } finally {
      setIsAccepting(false);
    }
  };

  // Sözleşme reddetme handler
  const handleDeclineTerms = async () => {
    setIsDeclining(true);
    try {
      await declineTerms();
    } catch {
      // toast already handled in context
    } finally {
      setIsDeclining(false);
      setShowDeclineWarning(false);
    }
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <LoginPage />
      ) : !hasAcceptedTerms && !isAdmin && !isStaff ? (
        // =============================================
        // SÖZLEŞME GATE - Dashboard render edilmez
        // Admin kullanıcılar sözleşmeden muaf
        // =============================================
        <>
          <TermsAgreementModal
            isNewUser={false} // Mevcut kullanıcılar için; yeni kullanıcı tespiti register flow'dan gelir
            onAccept={handleAcceptTerms}
            onDecline={() => setShowDeclineWarning(true)}
            isAccepting={isAccepting}
          />
          {showDeclineWarning && (
            <DeclineWarningModal
              onGoBack={() => setShowDeclineWarning(false)}
              onConfirmDecline={handleDeclineTerms}
              isDeclining={isDeclining}
            />
          )}
        </>
      ) : isAdmin ? (
        <AdminDashboard onLogout={logout} />
      ) : isStaff ? (
        <StaffDashboard onLogout={logout} />
      ) : (
        <Dashboard onLogout={logout} />
      )}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;